import { render, staticRenderFns } from "./FollowArtist.vue?vue&type=template&id=b22772be"
import script from "./FollowArtist.vue?vue&type=script&lang=js"
export * from "./FollowArtist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports